<template>
  <section class="flex items-center justify-center flex-1 overflow-y-auto">
    <div v-if="!query" class="flex-1 text-center">
      <h4 class="text-2xl font-semibold text-gray-900">No {{ capitalize(pluralize(label)) }}</h4>
      <p class="text-base text-gray-700 leading-9">{{ capitalize(action) }} a new {{ label }} to get started.</p>
    </div>
    <div v-else class="flex-1 text-center">
      <h4 class="text-2xl font-semibold text-gray-900">No {{ capitalize(pluralize(label)) }} Found</h4>
      <p class="text-base text-gray-700 leading-9">
        <span>The search for "{{ query }}" didn't return any results. Please try a different search.</span>
      </p>
    </div>
  </section>
</template>

<script lang="ts" setup>
defineProps({
  label: {
    required: true,
    type: String,
  },
  query: {
    type: String,
    default: null,
  },
  action: {
    required: true,
    type: String,
  },
})

function pluralize(label: string): string {
  return label + 's'
}

function capitalize(str: string): string {
  return str
    .split(' ')
    .map(word => word[0].toUpperCase() + word.substring(1))
    .join(' ')
}
</script>
